import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Drawer from './drawer';
import Button from '@99designs/react-components/components/Button';

const DrawerPlaceholder = ({ onClick }) => (
    <Button onClick={onClick} variations={['small', 'link']}>
        <Drawer variations={['flat']}>
            <div className="drawer__item--underline">
                <FormattedMessage id="select_winner_skip_message" />
            </div>
        </Drawer>
    </Button>
);

DrawerPlaceholder.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default DrawerPlaceholder;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/drawer-placeholder.jsx